import { frontendURL } from 'dashboard/helper/URLHelper.js';
import FlowsIndex from './pages/FlowsIndex.vue';
import FlowEditor from './pages/FlowEditor.vue';

// Flows visuais (Vincto). Gateado por permissao (admin), nao por feature flag.
const meta = {
  permissions: ['administrator'],
  featureModule: 'flows',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'flows_index',
    meta,
    component: FlowsIndex,
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId'),
    name: 'flows_editor',
    meta,
    component: FlowEditor,
  },
];
